// URL validation regex
const URL_REGEX = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+)(\/[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=]*)?$/;

// UUID validation regex
const UUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;

// Custom ID format used by the application (alphanumeric string with possible special chars)
const CUSTOM_ID_REGEX = /^[a-zA-Z0-9_-]{10,}$/;

// YouTube URL validation - includes music.youtube.com and international domains
const YOUTUBE_URL_REGEX = /^(https?:\/\/)?(www\.)?(music\.youtube\.[a-z]{2,}|youtube\.[a-z]{2,}|youtu\.be)\/.+/;

/**
 * Validates if the provided string is a valid URL, UUID, or custom ID
 * @param {string} value - The value to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const isValidUrlOrId = (value) => {
  if (!value) return false;
  
  // Trim any whitespace
  const trimmedValue = value.trim();
  
  // Check if it's a URL
  if (URL_REGEX.test(trimmedValue)) return true;
  
  // Check if it's a UUID
  if (UUID_REGEX.test(trimmedValue)) return true;
  
  // Check if it's a custom ID format
  if (CUSTOM_ID_REGEX.test(trimmedValue)) return true;
  
  return false;
};

/**
 * Validates if the provided string is a valid YouTube URL
 * @param {string} value - The value to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const isValidYoutubeUrl = (value) => {
  if (!value) return false;
  
  // Trim any whitespace
  const trimmedValue = value.trim();
  
  // Check if it's a YouTube URL
  return YOUTUBE_URL_REGEX.test(trimmedValue);
};

/**
 * Validates a form field
 * @param {string} name - Field name
 * @param {any} value - Field value
 * @param {boolean} required - Whether the field is required
 * @param {function} validationFn - Optional custom validation function
 * @returns {string|null} - Error message or null if valid
 */
export const validateField = (name, value, required, validationFn = null) => {
  // Check if field is required and empty
  if (required && (!value || (typeof value === 'string' && value.trim() === ''))) {
    return `${name} is required`;
  }
  
  // If field has a value and a validation function is provided, run it
  if (value && validationFn) {
    const isValid = validationFn(value);
    if (!isValid) {
      return `Please enter a valid ${name.toLowerCase()}`;
    }
  }
  
  return null;
};